// App version — injected from package.json by Vite's `define` config
const APP_VERSION = __APP_VERSION__;

// Build info injected by CI/CD during deployment
const COMMIT_ID = import.meta.env.VITE_COMMIT_ID || null;
const BUILD_NUMBER = import.meta.env.VITE_BUILD_NUMBER || null;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';

/**
 * Format version display string
 * - CI builds: "0.1.0(42)"
 * - Development: "0.1.0(dev)"
 */
function formatVersionDisplay(): string {
  if (BUILD_NUMBER) {
    return `${APP_VERSION} (${BUILD_NUMBER})`;
  }
  return `${APP_VERSION} (dev)`;
}

/**
 * Resolve the Bill.com "enhanced vendors" URL for the current environment.
 * Production points at the live Bill.com app; all other envs point at the
 * shared stage01 sandbox used for testing.
 */
function resolveBillcomVendorsUrl(): string {
  return `${resolveBillcomAppHost()}/neo/frame/enhanced-vendors-mfe`;
}

/**
 * MED-1383: the Bill.com host for the current environment. Production opens the live
 * Bill.com app; all other envs open the stage01 sandbox that staging bills go to.
 */
function resolveBillcomAppHost(): string {
  return ENVIRONMENT === 'production'
    ? 'https://app.bill.com'
    : 'https://app-stage01.us.bill.com';
}

/**
 * MED-1383: the Bill.com page of one bill. `/neo/bills/{id}` is verified on the
 * sandbox. The production path is assumed to match.
 */
export function resolveBillcomBillUrl(billId: string): string {
  return `${resolveBillcomAppHost()}/neo/bills/${encodeURIComponent(billId)}`;
}

export const env = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  sessionIntelligenceUrl: import.meta.env.VITE_SESSION_INTELLIGENCE_URL || 'http://localhost:3022',
  appTitle: import.meta.env.VITE_APP_TITLE || 'Medley App',
  nodeEnv: import.meta.env.VITE_NODE_ENV || 'development',
  isDev: import.meta.env.VITE_NODE_ENV === 'development',
  isProd: import.meta.env.VITE_NODE_ENV === 'production',
  // Version info for bug reporting
  appVersion: APP_VERSION,
  commitId: COMMIT_ID,
  buildNumber: BUILD_NUMBER,
  environment: ENVIRONMENT,
  // Formatted version string: "0.1.0 (42)" or "0.1.0 (dev)"
  versionDisplay: formatVersionDisplay(),
  // Bill.com vendors page (env-specific: sandbox for non-prod, live for prod)
  billcomVendorsUrl: resolveBillcomVendorsUrl(),
};
